import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import {
    getClientErrorRootOptions,
    installClientErrorReporting,
} from "@/utilities/client-error-reporting";
import App from "./App";
import "./index.css";

installClientErrorReporting("shared-applicant");

createRoot(
    document.getElementById("root"),
    getClientErrorRootOptions("shared-applicant"),
).render(
    <StrictMode>
        <App />
    </StrictMode>,
);
